import React, { Component } from 'react';
import firebase from 'firebase';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ReactExport from "react-data-export";
import Modal_empleados from './Modal_empleados';
import Modal from 'react-modal';
import Modal_Empresa from './empresa_modal';
import Alert from 'react-s-alert';
import store from '../../store';
import Slide from '../Globals/Slide/slide';
import MapaModal from '../Rutas/mapaModal';
import MapaRuta from '../Rutas/mapaRuta';
import SearchBox from 'react-google-maps/lib/components/places/SearchBox';
import copyright from '../../img/copyright-gray.png';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { sendLog } from '../../util'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

// import 'bootstrap/dist/css/bootstrap.min.css';

const google = window.google;
const DirectionsService = new google.maps.DirectionsService();

//Importando el store de redux


const database = firebase.database();

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '450px',
		height: '550px',

	}
};

const { SearchBar } = Search;
const rowClasses = 'table-bordered';

class Emp_Empleados extends Component {

	constructor(props) {

		super(props);
		this.state = {

			empleados: [],
			filteredEmpleados: [],
			isActive: false,
			empleadoKey: '',
			correo: '',
			dui: '',
			direccion: '',
			referencias: '',
			escalafon: '',
			numero_empleado: '',
			estado: '',
			nodo_empresa: '',
			nombre_empresa: '',
			preferencia: '',
			isActiveCosto: false,
			nom: '',
			Costos: [],
			codCosto: '',
			area: '',
			filtrado: 'si',
			empresaUID: '',
			coordenadas: [],
			localizacionL: { coordenadas: { lat: 13.6988044, lng: -89.2507203 }, eta: 0, referencia: '', placeName: '' },
			rutas: [],
			columns: [{
				dataField: 'key',
				text: 'Editar',
				formatter: (cellContent, row) => (
					<span> <button className="btn btn-success btn-sm" onClick={() => { this.handleClick(row) }} >&nbsp;&nbsp;&nbsp;&nbsp;Editar&nbsp;&nbsp;&nbsp;&nbsp;</button></span>
				)
			}, {
				dataField: 'key',
				hidden: true
			}, {
				dataField: 'nombreE',
				hidden: true
			},
			{
				dataField: 'apellidoE',
				hidden: true
			},
			{
				dataField: 'centroK',
				hidden: true
			}, {
				dataField: 'nombre',
				text: 'Nombre',
				sort: true,
				style: { 'white-space': 'nowrap' }

			}, {
				dataField: 'correo',
				text: 'Correo',
				sort: true
			}, {
				dataField: 'dui',
				text: 'Dui',
				sort: true
			}, {
				dataField: 'direccion',
				text: 'Direccion',
				sort: true,
				style: { 'white-space': 'nowrap' }
			}, {
				dataField: 'referencias',
				text: 'Referencias',
				sort: true,
				style: { 'white-space': 'nowrap' }
			}, {
				dataField: 'escalafon',
				text: 'Escalafon',
				sort: true
			}, {
				dataField: 'numero_empleado',
				text: 'Numero Empleado',
				sort: true,
				headerStyle: { 'white-space': 'nowrap' }
			}, {
				dataField: 'centro',
				text: 'Centro de Costos',
				sort: true,
				headerStyle: { 'white-space': 'nowrap' }
			}, {
				dataField: 'estado',
				text: 'Estado',
				sort: true
			},
			{
				dataField: 'tipoEmple',
				text: 'Tipo',
				sort: true
			}, {
				dataField: 'area',
				text: 'Area',
				sort: true
			}]

		}

		this.setMarkerG = this.setMarkerG.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.updateRow = this.updateRow.bind(this);
		this.toggleModalUpdate = this.toggleModalUpdate.bind(this);
		this.empleadosRef = database.ref().child('Clientes');
		this.ocultarMenu = this.ocultarMenu.bind(this);

		store.subscribe(() => {

			this.setState({

				nodo_empresa: store.getState().nodo_empresa,
				nombre_empresa: store.getState().nombre_empresa

			});

		});



	}

	componentWillMount() {
		Modal.setAppElement('body');
		let uid = this.props.EmpresaUID;
		this.setState({ empresaUID: uid })
	}

	componentWillUnmount = () => {
		this.empleadosRef.off();
	}

	onPlacesBusqueda = (index) => {
		const places = this.searchBox.getPlaces();
		const bounds = new google.maps.LatLngBounds();
		places.forEach(place => {
			if (place.geometry.viewport) {
				bounds.union(place.geometry.viewport)
			} else {
				bounds.extend(place.geometry.location)
			}
		});
		const nextMarkers = places.map(place => ({
			position: place.geometry.location,
		}));
		let e = nextMarkers[0].position;
		this.setMarkerG(e, index, 1)
	}

	componentDidMount() {

		firebase.database().ref('CentroCosto').once('value').then(data => {
			let Datos = [];
			const Base = data.val();
			if (data.val() !== null) {
				const keys = Object.keys(Base);
				for (let i = 0; i < keys.length; i++) {
					const k = keys[i];
					if (Base[k].empresa === this.state.empresaUID) {
						Datos.push({
							key: k,
							codigo: Base[k].codigo,
							descripcion: Base[k].descripcion,
							responsable: Base[k].responsable,
							area: Base[k].area
						})
					}
				}
				this.setState({ Costos: Datos });
			}
		});
		this.empleadosRef.off();
		this.empleadosRef.on('value', this.gotData, this.errData);

	}
	errDataSocios = (err) => {


	}

	handleChange(event, index) {
		let id = 'localizacion' + index;
		this.setState({ [id]: { ...this.state[id], referencia: event.target.value } })
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	setMarkerG(e, index, para) {
		let lat2 = 0;
		let lng2 = 0;
		if (para === 1) {
			lat2 = e.lat();
			lng2 = e.lng();
		}
		else {
			lat2 = e.latLng.lat();
			lng2 = e.latLng.lng();
		}
		let marker = 'showMarker' + index;
		let coordenadas = { lat: Number(lat2), lng: Number(lng2) }
		let id = 'localizacion' + index;

		fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat2 + ',' + lng2 + '&key=AIzaSyATad9mdS85bZPesVOnJpSP3BSwVAg60aY')
			.then(response => response.json())
			.catch(error => error)
			.then(responseJSON => {
				let nombreP = responseJSON.results[0].formatted_address;
				this.setState({ [id]: { ...this.state[id], coordenadas: coordenadas, placeName: nombreP }, [marker]: true })
			})
	}

	gotData = (data) => {
		let newEmpleado = []
		let codigo;
		const empleadodata = data.val();
		if (empleadodata != null) {
			const keys = Object.keys(empleadodata);

			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];

				for (let j = 0; j < this.state.Costos.length; j++) {
					if (this.state.Costos[j].key === empleadodata[k].centro) {
						codigo = this.state.Costos[j].codigo;
					}
				}

				const data = {
					key: k,
					nombre: empleadodata[k].nombre + ' ' + empleadodata[k].apellido,
					nombreE: empleadodata[k].nombre,
					apellidoE: empleadodata[k].apellido,
					correo: empleadodata[k].correo,
					dui: empleadodata[k].dui,
					direccion: empleadodata[k].direccion,
					referencias: empleadodata[k].referencias,
					escalafon: empleadodata[k].escalafon,
					numero_empleado: empleadodata[k].numero_empleado,
					estado: empleadodata[k].estado,
					preferencia: empleadodata[k].preferencia,
					centro: codigo,
					centroK: empleadodata[k].centro,
					area: empleadodata[k].areaDesc,
					tipoEmple: empleadodata[k].tipoEmple,
					localizacionL: empleadodata[k].coordenadas,
					ubicacionNombre: '',
				}
				if (data.localizacionL)
					data.localizacionL.placeName ? data.ubicacionNombre = data.localizacionL.placeName : data.ubicacionNombre = 'INDEFINIDO';
				newEmpleado.push(data);
			}
			this.setState({ empleados: newEmpleado, filteredEmpleados: newEmpleado });

		}

	}
	errData = (err) => {

	}

	generateBtnEditar(cell, row, rowIndex) {

		return <span> <button className="btn btn-success btn-sm" onClick={() => { this.handleClick(row) }} >Editar</button></span>;
	}

	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	generateBtnEmpleados(cell, row) {

		let url = '/ver viajes/' + row.key;

		return <Link to={url} className="btn btn-info btn-sm">Ver Empleados</Link>;

	}

	toggleModalUpdate() {



		this.setState({

			isActive: !this.state.isActive

		});


	}

	updateRow(event) {
		event.preventDefault();

		let key = this.state.empleadoKey;
		let dui = this.duiEmpleado.value;
		let direccion = this.direccion.value;
		let referencias = this.referencias.value;
		let escalafon = this.escalafon.value;
		let localizacionL = this.state.localizacionL;
		let numero_empleado = this.numeroEmpleado.value;
		let estado = this.estadoEmpleado.value;
		let preferencia = this.preferencia.value;
		let centro = this.state.codCosto;
		let area = this.area.value;
		let tipoEmple = this.tipoEmpleado.value;
		let nombre = this.nombreEmple.value; // Solo agregar para poder modificar nombre
		let apellido = this.apellidoEmple.value; // Solo agregar para poder modificar apellido

		database.ref().child('Clientes').child(key).update({
			nombre,
			apellido,
			dui,
			direccion,
			referencias,
			escalafon,
			tipoEmple,
			numero_empleado,
			estado,
			preferencia,
			centro,
			coordenadas: localizacionL,
			areaDesc: area,
		})

		sendLog({ tipo: 'empleado_avianca_editado', informacion_extra: { conductor: key } });
		Alert.success('Datos actualizados correctamente', {
			effect: 'genie',
			position: 'bottom-right',
			timeout: 2000
		});
		this.toggleModalUpdate();

	}


	handleClick(row) {


		this.setState({
			empleadoKey: row.key,
			dui: row.dui,
			direccion: row.direccion,
			referencias: row.referencias,
			escalafon: row.escalafon,
			correo: row.correo,
			numero_empleado: row.numero_empleado,
			estado: row.estado,
			preferencia: row.preferencia,
			nom: row.centro,
			area: row.area,
			codCosto: row.centroK,
			tipoEmpleado: row.tipoEmple,
			nombre: row.nombreE,
			apellido: row.apellidoE
		})

		this.toggleModalUpdate();
	}

	generateBtnVerViajes(cell, row) {


		let url = '/viajes/' + row.key;

		return <Link to={url} className="btn btn-info btn-sm">Ver Viajes</Link>;

	}

	toggleModalCosto = () => {
		this.setState({

			isActiveCosto: !this.state.isActiveCosto

		})
	}

	toggleModalG(index) {
		let active = 'isActive' + index;
		this.setState({
			[active]: !this.state[active]
		})
	}


	ocultarMenu() {


		store.dispatch({

			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	btnCostosFormatter(cell, row) {

		return <button className="btn btn-success btn-sm" onClick={() => { this.handleClickCostos(row) }} >Seleccionar</button>;
	}

	handleClickCostos = (rowKey) => {


		this.state.nom = rowKey.codigo;
		this.state.codCosto = rowKey.key;
		this.toggleModalCosto();

	}

	handleFiltering = (evt) => {
		const { empleados } = this.state;
		const searchValue = evt.target.value.toLowerCase().trim().split(' ');

		const filteredEmpleados = empleados.filter((empleado, i) => {
			let res = false;
			for (const prop in empleado) {
				if (searchValue.length == 1) {
					if (String(empleado[prop]).toLocaleLowerCase().includes(searchValue[0])) res = true;
				} else {
					//al menos 2 palabras de busqueda

					let coincidencias = 0;
					searchValue.forEach((value, i) => {
						if (String(empleado[prop]).toLocaleLowerCase().includes(value))
							coincidencias++;
					});

					if (coincidencias >= searchValue.length) res = true
				}
			}
			return res;
		});
		this.setState({ filteredEmpleados })

		// for (const item of filteredEmpleados) {
		// 	console.log('item.key :', item.key);
		// }

	}

	handlerDui = (evt) => {
		const val = evt.target.value;
		const arr = Array.from(val);
		const str = arr.filter(el => !/\D/.test(el)).join('');
		evt.target.value = str;
	}

	render() {

		let { rutas, coordenadas, localizacionL, empleados, columns, filteredEmpleados, isActive } = this.state;

		const columnSocios = [{
			dataField: 'key',
			text: 'Editar',
			formatter: (cellContent, row) => (
				<span> <button className="btn btn-success btn-sm" onClick={() => { this.handleClickCostos(row) }} >&nbsp;&nbsp;&nbsp;&nbsp;Seleccionar&nbsp;&nbsp;&nbsp;&nbsp;</button></span>
			)
		}, {
			dataField: 'key',
			hidden: true
		}, {
			dataField: 'codigo',
			text: 'Codigo',
			sort: true,
			style: { 'white-space': 'nowrap' }
		}, {
			dataField: 'area',
			text: 'Area',
			sort: true,
			style: { 'white-space': 'nowrap' }
		}];


		return (
			<div onClick={this.ocultarMenu}>
				<div className="empleados_empresa container" onClick={this.ocultarMenu}>

					<h5 style={{ textAlign: 'center' }} className="titulo-empresas">{store.getState().nombre_empresa}</h5>

					<Modal_empleados nodo={store.getState().nodo_empresa} />

					<div style={{ marginTop: 20 }}>
						<ExcelFile filename="Reportes de empleados Avianca" element={<button filename="Reporte empleados Avianca" className="btn btn-success">Exportar Excel</button>}>
							<ExcelSheet data={this.state.empleados} name="Detalle de Reporte">
								<ExcelColumn label="Nombre" value="nombre" />
								<ExcelColumn label="Correo" value="correo" />
								<ExcelColumn label="DUI" value="dui" />
								<ExcelColumn label="Dirección" value="direccion" />
								<ExcelColumn label="Referencia" value="referencia" />
								<ExcelColumn label="Escalafón" value="escalafon" />
								<ExcelColumn label="Número" value="numero_empleado" />
								<ExcelColumn label="Estado" value="estado" />
								<ExcelColumn label="Preferencias" value="preferencia" />
								<ExcelColumn label="Centro" value="centro" />
								<ExcelColumn label="Aréa" value="area" />
								<ExcelColumn label="Tipo de empleado" value="tipoEmple" />
								<ExcelColumn label="Localización" value="ubicacionNombre" />
							</ExcelSheet>
						</ExcelFile>
					</div>

					<div className="table-class">
						<ToolkitProvider
							keyField="key"
							data={isActive ? [] : filteredEmpleados}
							columns={columns}
							search={true}
						>
							{
								props => (
									<div>
										{/* <SearchBar {...props.searchProps} style={{ width: '30%', 'margin-left': '70%' }} /> */}
										<input style={{ width: '30%', 'margin-left': '70%' }} onChange={this.handleFiltering} className="form-control" placeholder='Buscar' />
										<hr />
										<BootstrapTable
											{...props.baseProps}
											rowClasses={rowClasses}
											pagination={paginationFactory()}
											striped
											hover
											condensed
											//filter={filterFactory()}
											bordered
											classes="custom-table"
										/>
									</div>
								)
							}
						</ToolkitProvider>
					</div>

					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate} style={customStyles}>

						<form method="POST" action="" onSubmit={this.updateRow}>

							<h3>Modificar Empleado</h3>
							<input type="hidden" name="key" value={this.state.empleadoKey} required />
							<hr />


							<div className="form-group">
								<label htmlFor="nombre">Nombre:</label>
								<input type="text" className="form-control" name="nombre"
									placeholder="Nombre" required autoComplete="off"
									defaultValue={this.state.nombre}
									ref={input => { this.nombreEmple = input }}
								/>
							</div>

							<div className="form-group">
								<label htmlFor="apellido">Apellido:</label>
								<input type="text" className="form-control" name="apellido"
									placeholder="Apellido" required autoComplete="off"
									defaultValue={this.state.apellido}
									ref={input => { this.apellidoEmple = input }}
								/>
							</div>


							<div className="form-group">
								<label htmlFor="correo">Correo:</label>
								<input type="text" className="form-control" name="correo"
									placeholder="Correo" required autoComplete="off"
									value={this.state.correo}
									disabled="disabled"

								/>
							</div>

							<div className="form-group">
								<label htmlFor="tipoEmpleado">Tipo empleado:</label>
								<select name="tipoEmpleado" defaultValue={this.state.tipoEmpleado} className="form-control"
									ref={input => { this.tipoEmpleado = input }}>
									<option>Piloto</option>
									<option>Tripulante de cabina</option>
									<option>Personal tierra</option>
								</select>
							</div>

							<div className="form-group">
								<label htmlFor="numero_empleado">Numero de empleado:</label>
								<input type="text" className="form-control" name="numero_empleado"
									placeholder="Numero de empleado" required autoComplete="off"
									defaultValue={this.state.numero_empleado}
									onChange={this.handlerDui}
									ref={input => { this.numeroEmpleado = input; }}
								/>
							</div>

							<div className="form-group">
								<label htmlFor="dui">Dui:</label>
								<input type="text" className="form-control" name="dui"
									placeholder="Dui" required autoComplete="off"
									defaultValue={this.state.dui}
									ref={input => { this.duiEmpleado = input }}
									onChange={this.handlerDui}
									maxLength="9" />
							</div>

							<div className="form-group">
								<label htmlFor="direccion">Dirección:</label>
								<textarea className="form-control" name="direccion"
									placeholder="Dirección" required autoComplete="off"
									defaultValue={this.state.direccion}
									ref={input => { this.direccion = input }} />
							</div>

							<div className="form-group">
								<label htmlFor="referencias">Referencias:</label>
								<input type="text" className="form-control" name="referencias"
									placeholder="Referencias" required autoComplete="off"
									defaultValue={this.state.referencias}
									ref={input => { this.referencias = input }} />
							</div>

							<div className="form-group">
								<label htmlFor="escalafon">Escalafón:</label>
								<input type="number" className="form-control" name="referencias"
									placeholder="Escalafón" required autoComplete="off"
									defaultValue={this.state.escalafon}
									ref={input => { this.escalafon = input }}
									min="0" max="150" step="1" />
							</div>

							<div className="form-group">
								<label htmlFor="localizacionL">Localización</label>
								<input type="text" defaultValue={this.state['localizacionL'].placeName} onClick={() => this.toggleModalG('L')} className="form-control" readOnly={true} placeholder="Ingrese ubicación" />
							</div>

							<div className="form-group">
								<label htmlFor="cento">Centro Costo</label>
								<input type="text" className="form-control"
									ref={input => { this.codCosto = input; }}
									readOnly="readonly" required autoComplete="off"
									onClick={this.toggleModalCosto}
									placeholder="Ejile una Centro de costos"
									value={this.state.nom}
								/>
							</div>

							<div className="form-group">
								<label htmlFor="estado">Estado:</label>
								<select name="estado" defaultValue={this.state.estado} className="form-control"
									ref={input => { this.estadoEmpleado = input }}
								>
									<option>Activo</option>
									<option>Inactivo</option>
									<option>Suspendido</option>

								</select>
							</div>

							<div className="form-group">
								<label htmlFor="preferencia">Preferencia:</label>
								<select className="form-control"
									ref={input => { this.preferencia = input }}
									defaultValue={this.state.preferencia}>
									<option>Taxi</option>
									<option>Microbus</option>
									<option>Privado</option>
									<option>Todos</option>
								</select>
							</div>
							<div className="form-group">
								<label htmlFor="nombre">Area</label>
								<input type="text" className="form-control" name="nombre"
									defaultValue={this.state.area}
									placeholder="Area" required autoComplete="off"
									ref={input => { this.area = input }} />
							</div>




							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
					</Modal>

					<Modal key={'modalL'} isOpen={this.state['isActiveL']} onRequestClose={() => this.toggleModalG('L')} style={customStyles}>
						<MapaModal
							googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyATad9mdS85bZPesVOnJpSP3BSwVAg60aY&v=3.exp&libraries=geometry,drawing,places"
							loadingElement={<div style={{ height: '100%', }} />}
							containerElement={<div style={{ height: '100%' }} />}
							mapElement={<div style={{ height: '100%', width: '100%' }} />}
							setMarker={(e) => this.setMarkerG(e, 'L', 0)}
							coordenadas={this.state['localizacionL'].coordenadas}
							showMarker={this.state['showMarkerL']}
						>
							<SearchBox
								ref={refs => this.searchBox = refs}
								onPlacesChanged={() => this.onPlacesBusqueda('L')}
								bounds={new google.maps.LatLngBounds(new google.maps.LatLng(Number(13.6988044), Number(-89.2507203)))}
								controlPosition={1}>
								<input
									type="text"
									defaultValue="San Salvador"
									className="validate"
									style={{
										boxSizing: `border-box`,
										border: `1px solid transparent`,
										width: `35%`,
										height: `40px`,
										marginTop: '10px',
										padding: `0 12px`,
										borderRadius: `3px`,
										boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
										fontSize: `14px`,
										fontColor: `black`,
										outline: `none`,
										textOverflow: `ellipses`,
									}}
								/>
							</SearchBox>
						</MapaModal>
					</Modal>



					<Modal isOpen={this.state.isActiveCosto} onRequestClose={this.toggleModalCosto} style={customStyles}>
						<h4>Selecciona un Centro de costos</h4>
						<hr />
						<ToolkitProvider
							keyField="key"
							data={this.state.Costos}
							columns={columnSocios}
							search={true}
						>
							{
								props => (
									<div>
										<SearchBar {...props.searchProps} style={{ width: '30%', 'margin-left': '70%' }} />
										<hr />
										<BootstrapTable
											{...props.baseProps}
											rowClasses={rowClasses}
											pagination={paginationFactory()}
											striped
											hover
											condensed
											//filter={filterFactory()}
											bordered
											classes="custom-table"
										/>
									</div>
								)
							}
						</ToolkitProvider>

					</Modal>
				</div>
				<footer className="footer-pg mt-auto py-3" style={{ width: '100%' }}>
					<div className="container">
						<div className="row">
							<div className="col-md-4 col-sm-4">
							</div>
							<div className="col-sm">
								<img src={copyright} />
							</div>
						</div>
					</div>
				</footer>
			</div>
		);


	}


}
const mapStateToProps = (state) => ({
	EmpresaUID: state.nodo_empresa
});

export default connect(mapStateToProps, null)(Emp_Empleados);


// WEBPACK FOOTER //
// ./src/Components/Emp_Empresas/Emp_Empleados.js